const CalendarIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0005 1.50049V4.50049M6.00049 1.50049V4.50049"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.75 3.00024H8.25C5.42157 3.00024 4.00736 3.00024 3.12868 3.87892C2.25 4.75761 2.25 6.17181 2.25 9.00024V10.5002C2.25 13.3286 2.25 14.7429 3.12868 15.6215C4.00736 16.5002 5.42157 16.5002 8.25 16.5002H9.75C12.5784 16.5002 13.9927 16.5002 14.8713 15.6215C15.75 14.7429 15.75 13.3286 15.75 10.5002V9.00024C15.75 6.17181 15.75 4.75761 14.8713 3.87892C13.9927 3.00024 12.5784 3.00024 9.75 3.00024Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.25 7.50024H15.75"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99711 10.5005H9.00386M8.99711 13.5005H9.00386M11.9937 10.5005H12.0005M6.00049 10.5005H6.00722M6.00049 13.5005H6.00722"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default CalendarIcon;
